module.exports = __webpack_public_path__ + "relogio.d16de0a645f2ffd6307258b744ea8137.jpg";